module.exports = __webpack_public_path__ + "img/ui.67bf78d0.svg";